import { render, staticRenderFns } from "./_base-button-genre.vue?vue&type=template&id=70808e6e&"
import script from "./_base-button-genre.vue?vue&type=script&lang=js&"
export * from "./_base-button-genre.vue?vue&type=script&lang=js&"
import style0 from "./_base-button-genre.vue?vue&type=style&index=0&id=70808e6e&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports